import DOMUtils from "@utils/dom.utils";
import richTextUtils from "../../utils/richtext.utils";
import ScrollUtils from "@utils/scroll.utils";

export default function (editor) {
  const richTextEditor = editor.options.get("richTextEditor");
  richTextEditor.plugins["externalMedia"] = {
    renderInEditor,
    cleanUp,
    containPluginElements,
  };

  editor.addCommand("mceExternalMediaDelete", (targetNode) => {
    richTextUtils.removeNodeFromEditor(editor, targetNode);
  });

  editor.on("click", (e) => {
    const target = e.target;
    if (target.closest("button.trash") && target.closest("button.trash").length !== 0) {
      const targetNode = target.closest(".sls-media-wrapper");
      if (targetNode) editor.execCommand("mceExternalMediaDelete", targetNode);
    }

    // cater for cases when have undo action
    handlePluginRerender(target);
  });

  function renderInEditor(rerender = false) {
    richTextUtils.renderInlineExternalMedia(editor, rerender);
  }

  function cleanUp(content) {
    let container = document.createElement("div");
    let containerAfterCleanUp = document.createElement("div");
    container.innerHTML = content;
    containerAfterCleanUp.innerHTML = content;

    // remove placeholder
    DOMUtils.elOf(containerAfterCleanUp, ".sls-media-wrapper").forEach((element) => {
      if (DOMUtils.elOf(element, ".inline-placeholder").length !== 0) {
        element.remove();
      }
    });
    DOMUtils.elOf(containerAfterCleanUp, ".inline-placeholder").forEach((element) => {
      element.remove();
    });
    DOMUtils.elOf(container, ".sls-external-media[data-type='external']").forEach((element) => {
      cleanUpElement(containerAfterCleanUp, element);
    });

    return containerAfterCleanUp.innerHTML;
  }

  function cleanUpElement(container, element) {
    let uuid = element.getAttribute("data-uuid");
    const media = DOMUtils.elOf(container, `.sls-external-media[data-uuid='${uuid}']`)[0];
    DOMUtils.removeClass(element, "loaded");
    const mediaWrapper = media.closest(".sls-media-wrapper");
    mediaWrapper && mediaWrapper.replaceWith(element);
  }

  function containPluginElements(container) {
    return DOMUtils.elOf(container, ".sls-external-media").length > 0;
  }

  function handlePluginRerender(target) {
    let mediaComponent = target.closest(".media-component");
    if (!mediaComponent || mediaComponent.length === 0 || mediaComponent.__vue__) return;

    let targetNode = mediaComponent.closest(".sls-media-wrapper")
      ? DOMUtils.elOf(
          mediaComponent.closest(".sls-media-wrapper"),
          ".sls-external-media[data-type='external']",
        )[0]
      : null;
    if (!targetNode) return;

    cleanUpElement(editor.getBody(), targetNode);
    renderInEditor(true);
  }
}
